import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
    faAnchor,
    faArrowTurnLeft,
    faArrowTurnLeftDown,
    faArrowTurnLeftUp,
    faArrowTurnRight,
    faBagShopping,
    faBagsShopping,
    faBanParking,
    faBarn,
    faBasketShopping,
    faBath,
    faBed,
    faBeerMugEmpty,
    faBell,
    faBellSlash,
    faBicycle,
    faBinoculars,
    faBook,
    faBookAtlas,
    faBookmark,
    faBridge,
    faBridgeSuspension,
    faBridgeWater,
    faBriefcase,
    faBuilding,
    faBuildingColumns,
    faCakeCandles,
    faCameraCctv,
    faCannon,
    faCar,
    faCartShopping,
    faCircleDollar,
    faCircleInfo,
    faCircleLocationArrow,
    faCircleParking,
    faCompassSlash,
    faCourtSport,
    faCrosshairs,
    faCrosshairsSimple,
    faDiamondTurnRight,
    faDoNotEnter,
    faDollarSign,
    faDrawCircle,
    faDrawPolygon,
    faDrawSquare,
    faDroplet,
    faExcavator,
    faEye,
    faEyeLowVision,
    faEyeSlash,
    faFire,
    faFireExtinguisher,
    faFireFlameCurved,
    faFlag,
    faFlagCheckered,
    faFlagPennant,
    faFlask,
    faFork,
    faForkKnife,
    faGamepad,
    faGavel,
    faGift,
    faGlobe,
    faGraduationCap,
    faHeart,
    faHeartPulse,
    faHeartSlash,
    faHelicopter,
    faHelicopterSymbol,
    faHospital,
    faHouse,
    faImage,
    faImages,
    faIndustry,
    faIndustryWindows,
    faInfo,
    faJetFighter,
    faKey,
    faKnife,
    faLandmark,
    faLandmarkFlag,
    faLayerGroup,
    faLayerMinus,
    faLayerPlus,
    faLeaf,
    faLemon,
    faLifeRing,
    faLightbulb,
    faLighthouse,
    faLocationArrow,
    faLocationArrowSlash,
    faLocationArrowUp,
    faLocationCheck,
    faLocationCrosshairs,
    faLocationCrosshairsSlash,
    faLocationDot,
    faLocationDotSlash,
    faLocationExclamation,
    faLocationMinus,
    faLocationPen,
    faLocationPin,
    faLocationPinLock,
    faLocationPinSlash,
    faLocationPlus,
    faLocationQuestion,
    faLocationSmile,
    faLocationXmark,
    faMagnet,
    faMagnifyingGlass,
    faMagnifyingGlassLocation,
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus,
    faMap,
    faMapPin,
    faMapSigns,
    faMartiniGlassEmpty,
    faMoneyBill,
    faMoneyBill1,
    faMonument,
    faMotorcycle,
    faMountainSun,
    faMugSaucer,
    faMusic,
    faNewspaper,
    faPaw,
    faPerson,
    faPersonWalkingWithCane,
    faPhone,
    faPhoneFlip,
    faPhoneVolume,
    faPlane,
    faPlaneEngines,
    faPlug,
    faPlus,
    faPrint,
    faRecycle,
    faRestroom,
    faRoad,
    faRocket,
    faRocketVertical,
    faRoute,
    faRouteHighway,
    faRouteInterstate,
    faScaleBalanced,
    faScaleUnbalanced,
    faScaleUnbalancedFlip,
    faShip,
    faShoePrints,
    faShower,
    faSignPost,
    faSignPosts,
    faSignPostsWrench,
    faSignsPost,
    faSkullCow,
    faSnowplow,
    faSpoon,
    faSquareDollar,
    faSquareH,
    faSquareInfo,
    faSquareParking,
    faSquareParkingSlash,
    faSquarePhone,
    faSquarePhoneFlip,
    faSquarePlus,
    faStreetView,
    faSuitcase,
    faSuitcaseMedical,
    faSwap,
    faSwapArrows,
    faTag,
    faTags,
    faTaxi,
    faThumbtack,
    faThumbtackAngle,
    faThumbtackAngleSlash,
    faThumbtackSlash,
    faTicket,
    faTicketSimple,
    faTickets,
    faTicketsSimple,
    faTrafficCone,
    faTrafficLight,
    faTrafficLightGo,
    faTrafficLightStop,
    faTrain,
    faTrainStop,
    faTrainSubway,
    faTrainTrack,
    faTrainTram,
    faTree,
    faTreeDeciduous,
    faTrophy,
    faTrophyStar,
    faTruck,
    faTruckFire,
    faTruckMedical,
    faTruckPlow,
    faTty,
    faTurnLeft,
    faTurnLeftDown,
    faTurnLeftUp,
    faTurnRight,
    faUmbrella,
    faUtensils,
    faVest,
    faVestPatches,
    faWheelchair,
    faWheelchairMove,
    faWifi,
    faWineGlass,
} from "@fortawesome/pro-solid-svg-icons";

export const mapsIcons: Record<string, IconDefinition> = {
    faAnchor: faAnchor,
    faArrowTurnLeft: faArrowTurnLeft,
    faArrowTurnLeftDown: faArrowTurnLeftDown,
    faArrowTurnLeftUp: faArrowTurnLeftUp,
    faArrowTurnRight: faArrowTurnRight,
    faBagShopping: faBagShopping,
    faBagsShopping: faBagsShopping,
    faBanParking: faBanParking,
    faBarn: faBarn,
    faBasketShopping: faBasketShopping,
    faBath: faBath,
    faBed: faBed,
    faBeerMugEmpty: faBeerMugEmpty,
    faBell: faBell,
    faBellSlash: faBellSlash,
    faBicycle: faBicycle,
    faBinoculars: faBinoculars,
    faBook: faBook,
    faBookAtlas: faBookAtlas,
    faBookmark: faBookmark,
    faBridge: faBridge,
    faBridgeSuspension: faBridgeSuspension,
    faBridgeWater: faBridgeWater,
    faBriefcase: faBriefcase,
    faBuilding: faBuilding,
    faBuildingColumns: faBuildingColumns,
    faCakeCandles: faCakeCandles,
    faCameraCctv: faCameraCctv,
    faCannon: faCannon,
    faCar: faCar,
    faCartShopping: faCartShopping,
    faCircleDollar: faCircleDollar,
    faCircleInfo: faCircleInfo,
    faCircleLocationArrow: faCircleLocationArrow,
    faCircleParking: faCircleParking,
    faCompassSlash: faCompassSlash,
    faCourtSport: faCourtSport,
    faCrosshairs: faCrosshairs,
    faCrosshairsSimple: faCrosshairsSimple,
    faDiamondTurnRight: faDiamondTurnRight,
    faDoNotEnter: faDoNotEnter,
    faDollarSign: faDollarSign,
    faDrawCircle: faDrawCircle,
    faDrawPolygon: faDrawPolygon,
    faDrawSquare: faDrawSquare,
    faDroplet: faDroplet,
    faExcavator: faExcavator,
    faEye: faEye,
    faEyeLowVision: faEyeLowVision,
    faEyeSlash: faEyeSlash,
    faFire: faFire,
    faFireExtinguisher: faFireExtinguisher,
    faFireFlameCurved: faFireFlameCurved,
    faFlag: faFlag,
    faFlagPennant: faFlagPennant,
    faFlagCheckered: faFlagCheckered,
    faFlask: faFlask,
    faFork: faFork,
    faForkKnife: faForkKnife,
    faGamepad: faGamepad,
    faGavel: faGavel,
    faGift: faGift,
    faGlobe: faGlobe,
    faGraduationCap: faGraduationCap,
    faHeart: faHeart,
    faHeartPulse: faHeartPulse,
    faHeartSlash: faHeartSlash,
    faHelicopter: faHelicopter,
    faHelicopterSymbol: faHelicopterSymbol,
    faHospital: faHospital,
    faHouse: faHouse,
    faImage: faImage,
    faImages: faImages,
    faIndustry: faIndustry,
    faIndustryWindows: faIndustryWindows,
    faInfo: faInfo,
    faJetFighter: faJetFighter,
    faKey: faKey,
    faKnife: faKnife,
    faLandmark: faLandmark,
    faLandmarkFlag: faLandmarkFlag,
    faLayerGroup: faLayerGroup,
    faLayerMinus: faLayerMinus,
    faLayerPlus: faLayerPlus,
    faLeaf: faLeaf,
    faLemon: faLemon,
    faLifeRing: faLifeRing,
    faLightbulb: faLightbulb,
    faLighthouse: faLighthouse,
    faLocationArrow: faLocationArrow,
    faLocationArrowSlash: faLocationArrowSlash,
    faLocationArrowUp: faLocationArrowUp,
    faLocationCheck: faLocationCheck,
    faLocationCrosshairs: faLocationCrosshairs,
    faLocationCrosshairsSlash: faLocationCrosshairsSlash,
    faLocationDot: faLocationDot,
    faLocationDotSlash: faLocationDotSlash,
    faLocationExclamation: faLocationExclamation,
    faLocationMinus: faLocationMinus,
    faLocationPen: faLocationPen,
    faLocationPin: faLocationPin,
    faLocationPinLock: faLocationPinLock,
    faLocationPinSlash: faLocationPinSlash,
    faLocationPlus: faLocationPlus,
    faLocationQuestion: faLocationQuestion,
    faLocationSmile: faLocationSmile,
    faLocationXmark: faLocationXmark,
    faMagnet: faMagnet,
    faMagnifyingGlass: faMagnifyingGlass,
    faMagnifyingGlassLocation: faMagnifyingGlassLocation,
    faMagnifyingGlassMinus: faMagnifyingGlassMinus,
    faMagnifyingGlassPlus: faMagnifyingGlassPlus,
    faMap: faMap,
    faMapPin: faMapPin,
    faMapSigns: faMapSigns,
    faMartiniGlassEmpty: faMartiniGlassEmpty,
    faMoneyBill: faMoneyBill,
    faMoneyBill1: faMoneyBill1,
    faMonument: faMonument,
    faMotorcycle: faMotorcycle,
    faMountainSun: faMountainSun,
    faMugSaucer: faMugSaucer,
    faMusic: faMusic,
    faNewspaper: faNewspaper,
    faPaw: faPaw,
    faPerson: faPerson,
    faPersonWalkingWithCane: faPersonWalkingWithCane,
    faPhone: faPhone,
    faPhoneFlip: faPhoneFlip,
    faPhoneVolume: faPhoneVolume,
    faPlane: faPlane,
    faPlaneEngines: faPlaneEngines,
    faPlug: faPlug,
    faPlus: faPlus,
    faPrint: faPrint,
    faRecycle: faRecycle,
    faRestroom: faRestroom,
    faRoad: faRoad,
    faRocket: faRocket,
    faRocketVertical: faRocketVertical,
    faRoute: faRoute,
    faRouteHighway: faRouteHighway,
    faRouteInterstate: faRouteInterstate,
    faScaleBalanced: faScaleBalanced,
    faScaleUnbalanced: faScaleUnbalanced,
    faScaleUnbalancedFlip: faScaleUnbalancedFlip,
    faShip: faShip,
    faShoePrints: faShoePrints,
    faShower: faShower,
    faSignPost: faSignPost,
    faSignPosts: faSignPosts,
    faSignPostsWrench: faSignPostsWrench,
    faSignsPost: faSignsPost,
    faSkullCow: faSkullCow,
    faSnowplow: faSnowplow,
    faSpoon: faSpoon,
    faSquareDollar: faSquareDollar,
    faSquareH: faSquareH,
    faSquareInfo: faSquareInfo,
    faSquareParking: faSquareParking,
    faSquareParkingSlash: faSquareParkingSlash,
    faSquarePhone: faSquarePhone,
    faSquarePhoneFlip: faSquarePhoneFlip,
    faSquarePlus: faSquarePlus,
    faStreetView: faStreetView,
    faSuitcase: faSuitcase,
    faSuitcaseMedical: faSuitcaseMedical,
    faSwap: faSwap,
    faSwapArrows: faSwapArrows,
    faTag: faTag,
    faTags: faTags,
    faTaxi: faTaxi,
    faThumbtack: faThumbtack,
    faThumbtackAngle: faThumbtackAngle,
    faThumbtackAngleSlash: faThumbtackAngleSlash,
    faThumbtackSlash: faThumbtackSlash,
    faTicket: faTicket,
    faTicketSimple: faTicketSimple,
    faTickets: faTickets,
    faTicketsSimple: faTicketsSimple,
    faTrafficCone: faTrafficCone,
    faTrafficLight: faTrafficLight,
    faTrafficLightGo: faTrafficLightGo,
    faTrafficLightStop: faTrafficLightStop,
    faTrain: faTrain,
    faTrainStop: faTrainStop,
    faTrainSubway: faTrainSubway,
    faTrainTrack: faTrainTrack,
    faTrainTram: faTrainTram,
    faTree: faTree,
    faTreeDeciduous: faTreeDeciduous,
    faTrophy: faTrophy,
    faTrophyStar: faTrophyStar,
    faTruck: faTruck,
    faTruckFire: faTruckFire,
    faTruckMedical: faTruckMedical,
    faTruckPlow: faTruckPlow,
    faTty: faTty,
    faTurnLeft: faTurnLeft,
    faTurnLeftDown: faTurnLeftDown,
    faTurnLeftUp: faTurnLeftUp,
    faTurnRight: faTurnRight,
    faUmbrella: faUmbrella,
    faUtensils: faUtensils,
    faVest: faVest,
    faVestPatches: faVestPatches,
    faWheelchair: faWheelchair,
    faWheelchairMove: faWheelchairMove,
    faWifi: faWifi,
    faWineGlass: faWineGlass,
};

export const mapsIconNames = Object.keys(mapsIcons);
